import { cn } from '@/lib/utils'

export type Status = 'ok' | 'warn' | 'critical' | 'unknown' | 'info'

const DOT_CLASS: Record<Status, string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  critical: 'bg-critical',
  unknown: 'bg-unknown',
  info: 'bg-info',
}

const CHIP_CLASS: Record<Status, string> = {
  ok: 'bg-ok-weak text-ok',
  warn: 'bg-warn-weak text-warn',
  critical: 'bg-critical-weak text-critical',
  unknown: 'bg-unknown-weak text-unknown',
  info: 'bg-info-weak text-info',
}

export function StatusDot({ status, className }: { status: Status; className?: string }) {
  return <span className={cn('inline-block h-[7px] w-[7px] rounded-full', DOT_CLASS[status], className)} />
}

export function StatusChip({
  status,
  children,
  stale,
  className,
}: {
  status: Status
  children?: React.ReactNode
  stale?: boolean
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-[5px] px-1.5 py-0.5 text-[11px] font-semibold',
        CHIP_CLASS[status],
        stale && 'italic',
        className,
      )}
    >
      <StatusDot status={status} />
      {children ?? status}
    </span>
  )
}
